export const createDashboardSlice = (set) => ({
  statsData: {},
  setStatsData: (data) => set({ statsData: data }),
  surveillanceStatsData: {},
  setSurveillanceStatsData: (data) => set({ surveillanceStatsData: data }),
  hideLicense: false,
});
